var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
var dots = '...';
/**
 * @hidden
 */

var PagerNumericButtons = function (_super) {
  __extends(PagerNumericButtons, _super);

  function PagerNumericButtons() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handlePageChange = function (e, page) {
      e.preventDefault();

      _this.props.pageChange(page, e);
    };

    _this.handleSelectPageChange = function (e) {
      e.preventDefault();

      _this.props.pageChange(e.target.value, e);
    };

    return _this;
  }

  PagerNumericButtons.prototype.render = function () {
    var _this = this;

    var prevDots = this.start > 1 && this.renderDots(this.start - 1);
    var postDots = this.end < this.props.totalPages && this.renderDots(this.end + 1);
    var prevOptionDots = this.start > 1 && this.renderOptionDots(this.start - 1);
    var postOptionDots = this.end < this.props.totalPages && this.renderOptionDots(this.end + 1);
    var buttons = [];

    for (var idx = this.start; idx <= this.end; idx++) {
      buttons.push(idx);
    }

    var numerics = buttons.map(function (page) {
      return React.createElement("li", {
        key: page
      }, React.createElement("a", {
        href: "#",
        onClick: function onClick(e) {
          return _this.handlePageChange(e, page);
        },
        className: classNames('k-link', {
          'k-state-selected': _this.props.currentPage === page
        })
      }, page));
    });
    var options = buttons.map(function (page) {
      return React.createElement("option", {
        key: page,
        className: classNames('k-link')
      }, page);
    });
    return React.createElement("div", {
      className: "k-pager-numbers-wrap"
    }, React.createElement("select", {
      className: "k-dropdown",
      value: this.props.currentPage,
      onChange: function onChange(e) {
        return _this.handleSelectPageChange(e);
      }
    }, prevOptionDots, options, postOptionDots), React.createElement("ul", {
      className: "k-pager-numbers k-reset"
    }, prevDots, numerics, postDots));
  };

  PagerNumericButtons.prototype.renderDots = function (page) {
    var _this = this;

    return React.createElement("li", null, React.createElement("a", {
      className: "k-link",
      onClick: function onClick(e) {
        return _this.handlePageChange(e, page);
      },
      href: "#"
    }, dots));
  };

  PagerNumericButtons.prototype.renderOptionDots = function (page) {
    return React.createElement("option", {
      className: "k-link",
      value: page
    }, dots);
  };

  Object.defineProperty(PagerNumericButtons.prototype, "end", {
    get: function get() {
      return Math.min(this.start + this.props.buttonCount - 1, this.props.totalPages);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PagerNumericButtons.prototype, "start", {
    get: function get() {
      var page = this.props.currentPage;
      var buttonCount = this.props.buttonCount;

      if (page > buttonCount) {
        var reminder = page % buttonCount;
        return reminder === 0 ? page - buttonCount + 1 : page - reminder + 1;
      }

      return 1;
    },
    enumerable: true,
    configurable: true
  });
  return PagerNumericButtons;
}(React.Component);

export { PagerNumericButtons };